"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.regexp.search");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.set");
require("core-js/modules/es6.array.from");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _batchReservationNb = _interopRequireDefault(require("./components/batchReservationNb"));
var _batchReservationPh = _interopRequireDefault(require("./components/batchReservationPh"));
var _batchReservationQd = _interopRequireDefault(require("./components/batchReservationQd"));
var _batchReservationSk = _interopRequireDefault(require("./components/batchReservationSk"));
var _batchReservationXg = _interopRequireDefault(require("./components/batchReservationXg"));
var _batchReservationXm = _interopRequireDefault(require("./components/batchReservationXm"));
var _searchContainerPh = _interopRequireDefault(require("./components/searchContainerPh"));
var _confirmPrintingDialog = _interopRequireDefault(require("./components/confirmPrintingDialog"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _vue = require("@handsontable/vue");
var _vuex = require("vuex");
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _ClearableTextInput = _interopRequireDefault(require("@/components/ClearableTextInput"));
var _validate = require("@/utils/validate");
var _batchReservationComm = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/batchReservationComm.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "blExchangeAppointment",
  components: {
    BatchReservationComm: _batchReservationComm.default,
    HotColumn: _vue.HotColumn,
    batchReservationNb: _batchReservationNb.default,
    batchReservationPh: _batchReservationPh.default,
    batchReservationQd: _batchReservationQd.default,
    batchReservationSk: _batchReservationSk.default,
    batchReservationXg: _batchReservationXg.default,
    batchReservationXm: _batchReservationXm.default,
    searchContainer: _searchContainerPh.default,
    confirmPrintingDialog: _confirmPrintingDialog.default,
    Pagination: _Pagination.default,
    filterColumn: _index.default,
    ClearableTextInput: _ClearableTextInput.default
  },
  data: function data() {
    return {
      loading: null,
      tableData: [],
      // 表格数据
      tableCostData: [],
      portCodes: [],
      //用户港口权限
      formDialog: {},
      forespeakBlNo: [],
      printDialog: {},
      total: 0,
      totalCost: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 10,
        namedParameters: {}
      },
      listQueryTwo: {
        currentPage: 1,
        pageSize: 10,
        namedParameters: {}
      },
      filterForm: {
        blNo: '',
        portCode: ''
      },
      hotSettings: {
        dragCheck: true,
        height: 'calc(100px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true
      },
      hotCostSettings: {
        dragCheck: true,
        height: 'calc(100px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      searchContainerDialogVisible: false,
      confirmPrintingDialogVisible: false,
      batchReservationNbVisible: false,
      // 宁波初始化弹窗状态
      batchReservationPhVisible: false,
      // PH初始化弹窗状态
      del: '',
      batchReservationQdVisible: false,
      //青岛初始化弹窗状态
      batchReservationSkVisible: false,
      // 蛇口初始化弹窗状态
      batchReservationXgVisible: false,
      //新港初始化弹窗状态
      batchReservationXmVisible: false,
      //厦门初始化弹窗状态
      batchReservationCommonVisible: false,
      //公共初始化弹窗状态
      rules: {
        blNo: [{
          required: true,
          message: this.$t('blExchangeAppointment.blNoNotEmpty'),
          trigger: 'blur'
        }],
        portCode: [{
          required: true,
          message: this.$t('blExchangeAppointment.portCodeEmpty'),
          trigger: 'blur'
        }]
      },
      vvLBlNo: '',
      vvls: [],
      edoCreditId: '',
      paymentStatus: null,
      forespeakStatus: null,
      paymentStatusList: [],
      forespeakStatusList: [],
      edoPaymentMethod: [],
      ecmNgbEdoOwnerType: [],
      releaseStatusList: [],
      releaseStatusMap: new Map(),
      slipUploadFlag: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['EDO_PAYMENT_METHOD', 'DOC_PAYMENT_STATUS', 'DOC_FORESPEAK_STATUS', 'ECM_NGB_EDO_OWNER_TYPE', 'RELEASE_STATUS'], true).then(function (res) {
      _this.edoPaymentMethod = res.EDO_PAYMENT_METHOD ? res.EDO_PAYMENT_METHOD : [];
      _this.paymentStatusList = res.DOC_PAYMENT_STATUS ? res.DOC_PAYMENT_STATUS : [];
      _this.forespeakStatusList = res.DOC_FORESPEAK_STATUS ? res.DOC_FORESPEAK_STATUS : [];
      _this.ecmNgbEdoOwnerType = res.ECM_NGB_EDO_OWNER_TYPE ? res.ECM_NGB_EDO_OWNER_TYPE : [];
      _this.releaseStatusList = res.RELEASE_STATUS ? res.RELEASE_STATUS : [];
      _this.releaseStatusList.push({
        codeValue: '0',
        displayValue: 'Not Release',
        displayValueCn: '未放单'
      });
      _this.releaseStatusMap = new Map();
      _this.releaseStatusList.forEach(function (item) {
        var key = item.codeValue;
        _this.releaseStatusMap.set(key, _this.language === 'zh' ? item.displayValueCn : item.displayValue);
      });
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    this.querySysAccountPort();
    this.$nextTick(function () {
      _this2.resizeHotTable();
    });
  },
  methods: {
    querySysAccountPort: function querySysAccountPort() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.querySysAccountPort)().then(function (res) {
        if (res.success) {
          _this3.portCodes = res.data;
        }
      }).catch(function (error) {}).finally(function () {
        _this3.loading.close();
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    searchFnCost: function searchFnCost(val) {
      this.listQueryTwo.currentPage = val.page;
      this.listQueryTwo.pageSize = val.limit;
      this.handleSearch();
    },
    handleCloseReservationNb: function handleCloseReservationNb() {
      this.batchReservationNbVisible = false;
      this.handleSearch();
    },
    handleCloseReservationXm: function handleCloseReservationXm() {
      this.batchReservationXmVisible = false;
      this.handleSearch();
    },
    handleCloseReservationSk: function handleCloseReservationSk() {
      this.batchReservationSkVisible = false;
      this.handleSearch();
    },
    handleCloseReservationQd: function handleCloseReservationQd() {
      this.batchReservationQdVisible = false;
      this.handleSearch();
    },
    handleCloseReservationXg: function handleCloseReservationXg() {
      this.batchReservationXgVisible = false;
      this.handleSearch();
    },
    handleViewDetail: function handleViewDetail(row) {
      var _this4 = this;
      this.formDialog = {};
      //当是非SIT承运人时候在正本提单提示之前加提示
      var hasNotSIT1 = false;
      var hasNotSIT2 = false;
      var hasOriginalBlNo = false;
      var selectedRow = this.$refs.hotTable.getSelected();
      if (!selectedRow.deliverableDate) {
        this.$message.error(this.$t('blExchangeAppointment.noDeliverableDate'));
        return;
      }
      if (selectedRow.edoSentStatus == 1) {
        this.$message.error(this.$t('blExchangeAppointment.edosentstatusNotEdit'));
        return;
      }
      if (selectedRow.del === "CNSHK") {
        if (selectedRow.carrierCode !== 'SIT') {
          if ((0, _validate.validateNull)(selectedRow.releaseStatus)) {
            hasNotSIT1 = true;
          } else {
            hasNotSIT2 = true;
          }
        }
        if (selectedRow.carrierCode === 'SIT' && selectedRow.paymentStatus === 0) {
          this.$message.error(this.$t('blExchangeAppointment.manifestUnpaid'));
          return;
        }
        if (selectedRow.carrierCode !== 'SIT') {
          hasOriginalBlNo = true;
        } else {
          if (!(selectedRow.releaseStatus == '2' || selectedRow.releaseStatus == '3')) {
            hasOriginalBlNo = true;
          }
        }
        if (hasOriginalBlNo) {
          if (hasNotSIT1 || hasNotSIT2) {
            this.$confirm(hasNotSIT1 ? this.$t('blExchangeAppointment.contactCompany') : this.$t('blExchangeAppointment.payOnSite'), this.$t('confirmMsg.title'), {
              confirmButtonText: this.$t('confirmMsg.submit'),
              cancelButtonText: this.$t('confirmMsg.cancel'),
              type: 'warning'
            }).then(function () {
              if (!(selectedRow.releaseStatus == '2' || selectedRow.releaseStatus == '3')) {
                _this4.$confirm(_this4.$t('blExchangeAppointment.confirmOriginalBl'), _this4.$t('confirmMsg.title'), {
                  confirmButtonText: _this4.$t('confirmMsg.submit'),
                  cancelButtonText: _this4.$t('confirmMsg.cancel'),
                  type: 'warning'
                }).then(function () {
                  _this4.handleSelectedRow(selectedRow);
                }).catch(function () {
                  _this4.$message({
                    type: 'info',
                    message: _this4.$t('blExchangeAppointment.portReleasePending')
                  });
                  return;
                });
              } else {
                _this4.handleSelectedRow(selectedRow);
              }
            });
          } else {
            this.$confirm(this.$t('blExchangeAppointment.confirmOriginalBl'), this.$t('confirmMsg.title'), {
              confirmButtonText: this.$t('confirmMsg.submit'),
              cancelButtonText: this.$t('confirmMsg.cancel'),
              type: 'warning'
            }).then(function () {
              _this4.handleSelectedRow(selectedRow);
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: _this4.$t('blExchangeAppointment.portReleasePending')
              });
              return;
            });
          }
        } else {
          this.handleSelectedRow(selectedRow);
        }
      } else {
        this.handleSelectedRow(selectedRow);
      }
    },
    handleSelectedRow: function handleSelectedRow(selectedRow) {
      if (this.filterForm.portCode == 'CNSHK') {
        this.vvLBlNo = "VVL:".concat(selectedRow.outVesselCode, "/").concat(selectedRow.outVoyageNo).concat(selectedRow.outVoyageLeg, ",BL:").concat(selectedRow.blNo, ",RS:").concat(this.releaseStatusMap.get(selectedRow.releaseStatus));
      } else {
        this.vvLBlNo = "VVL:".concat(selectedRow.outVesselCode, "/").concat(selectedRow.outVoyageNo).concat(selectedRow.outVoyageLeg, ",BL:").concat(selectedRow.blNo);
      }
      this.forespeakBlNo = selectedRow.blNo.split(',');
      if (selectedRow.del.startsWith('PH')) {
        this.printDialog = {
          bookingHeadIds: selectedRow.bookingHeadId,
          blNo: selectedRow.blNo,
          eta: selectedRow.eta,
          del: selectedRow.del
        };
      }
      if (selectedRow.isLock == 1) {
        this.$message.error(this.$t('blExchangeAppointment.lockNotLook'));
        return;
      }
      if (selectedRow.edoCreditId) {
        this.edoCreditId = selectedRow.edoCreditId;
      } else {
        this.edoCreditId = '';
      }
      // 海港校验是否上传水单
      if (this.filterForm.portCode == 'CNTXG') {
        this.slipUploadFlag = selectedRow.slipUpload == '1';
      }
      this.setDialogVisible(selectedRow.del);
    },
    //查询
    handleSearch: function handleSearch() {
      var _this5 = this;
      this.listQuery.namedParameters = this.filterForm;
      this.listQueryTwo.namedParameters = this.filterForm;
      this.tableCostData = [];
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this5.loading = (0, _utils.load)();
          (0, _blExchangeAppointment.getBookedBl)(_this5.filterForm).then(function (res) {
            if (res.success) {
              if (res.data) {
                _this5.$message({
                  showClose: true,
                  message: _this5.$t('blExchangeAppointment.bookedBl').replace(/\n/g, '<br>') + res.data.replace(/,/g, '<br>'),
                  type: 'warning',
                  dangerouslyUseHTMLString: true
                });
              }
            }
          });
          (0, _blExchangeAppointment.search)(_this5.listQuery).then(function (res) {
            if (res.success) {
              _this5.total = res.data.totalRecord;
              _this5.tableData = res.data.records;
              if (_this5.tableData.length != 0) {
                _this5.hotSettings.height = 'calc(50vh - 230px)';
              }
              // 在数据加载后延迟执行以确保表格已完全渲染
              _this5.$nextTick(function () {
                setTimeout(function () {
                  if (_this5.$refs.hotTable && _this5.$refs.hotTable.hotInstance) {
                    _this5.$refs.hotTable.hotInstance.loadData(_this5.tableData);
                    _this5.resizeHotTable(); // 确保表格尺寸正确
                    setTimeout(function () {
                      if (_this5.tableData && _this5.tableData.length > 0) {
                        var hotInstance = _this5.$refs.hotTable.hotInstance;
                        hotInstance.selectRows(0, 0, false);
                        // 调用handleDouble方法，传入第一行的索引
                        _this5.handleDouble({
                          physicalRow: 0
                        });
                      }
                    }, 200); // 增加延迟时间，确保DOM已完全渲染
                  }
                }, 200);
              });
            }
          }).finally(function () {
            _this5.loading.close();
          });
        }
      });
    },
    handleDouble: function handleDouble(_ref) {
      var _this6 = this;
      var physicalRow = _ref.physicalRow;
      var select = this.tableData[physicalRow];
      var object = {
        blNo: select.blNo,
        portCode: select.del
      };
      this.listQueryTwo.namedParameters = object;
      (0, _blExchangeAppointment.searchFreight)(this.listQueryTwo).then(function (res) {
        if (res.success) {
          _this6.tableCostData = res.data.records;
          _this6.totalCost = res.data.totalRecord;
          if (_this6.tableCostData.length != 0) {
            _this6.hotCostSettings.height = 'calc(50vh - 230px)';
          }
        }
      }).finally(function () {});
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
      this.$refs.hotTableCost.resizeTo();
    },
    //重置
    resetFn: function resetFn() {
      this.filterForm.blNo = '';
      this.filterForm.portCode = '';
    },
    handleBatchReservation: function handleBatchReservation() {
      var _this7 = this;
      // 批量处理，清除单选主键
      this.edoCreditId = '';
      //获取勾选行
      var hotTableSelections = this.$refs.hotTable.getSelections();
      //判断是否存在勾选数据  请勾选数据
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('blExchangeAppointment.pleaseCheckData'));
        return;
      }
      //判断是否是同一个港口
      var firstPort = hotTableSelections[0].del;
      var hasDifferentPort = hotTableSelections.some(function (selection) {
        return selection.del !== firstPort;
      });
      if (hasDifferentPort) {
        this.$message.error(this.$t('blExchangeAppointment.checkSamePort'));
        return;
      }

      // 判断是否为CNXMN港口
      var isCNXMN = this.filterForm.portCode && this.filterForm.portCode === 'CNXMN' || firstPort && firstPort === 'CNXMN';

      // 如果是CNXMN，只取第一个选中行的edoCreditId
      if (isCNXMN && hotTableSelections.length > 0) {
        // 获取第一个有效的edoCreditId
        var firstSelection = hotTableSelections.find(function (selection) {
          return selection.edoCreditId;
        });
        if (firstSelection && firstSelection.edoCreditId) {
          this.edoCreditId = firstSelection.edoCreditId;
        }
      }
      var hasEmptyDeliverableDate = false;
      var hasEdoSentStatus = false;
      var hasOriginalBlNo = false;
      //当是非SIT承运人时候在正本提单提示之前加提示
      var hasNotSIT1 = false;
      var hasNotSIT2 = false;
      var hasNotSIT3 = false;
      var _iterator = (0, _createForOfIteratorHelper2.default)(hotTableSelections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selection = _step.value;
          //舱单未付款，请付款后进行预约
          if (selection.del == "CNSHK") {
            if (selection.carrierCode !== 'SIT') {
              if ((0, _validate.validateNull)(selection.releaseStatus)) {
                hasNotSIT1 = true;
              } else {
                hasNotSIT2 = true;
              }
            }
            if (selection.carrierCode === 'SIT' && selection.paymentStatus === 0) {
              this.$message.error(this.$t('blExchangeAppointment.manifestUnpaid'));
              return;
            }
            if (selection.carrierCode !== 'SIT') {
              hasOriginalBlNo = true;
              if (!(selection.releaseStatus == '2' || selection.releaseStatus == '3')) {
                hasNotSIT3 = true;
              }
              break;
            }
            if (!(selection.releaseStatus == '2' || selection.releaseStatus == '3')) {
              hasOriginalBlNo = true;
              break;
            }
          }
          if (!selection.deliverableDate && selection.del !== 'CNDLC') {
            hasEmptyDeliverableDate = true;
            break;
          }
          if (selection.edoSentStatus == 1) {
            hasEdoSentStatus = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (hasEmptyDeliverableDate) {
        this.$message.error(this.$t('blExchangeAppointment.noDeliverableDate'));
        return;
      }
      if (hasEdoSentStatus) {
        this.$message.error(this.$t('blExchangeAppointment.edosentstatusNotEdit'));
        return;
      }
      if (hasOriginalBlNo) {
        if (hasNotSIT1 || hasNotSIT2) {
          this.$confirm(hasNotSIT1 ? this.$t('blExchangeAppointment.contactCompany') : this.$t('blExchangeAppointment.payOnSite'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.submit'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            if (hasNotSIT3) {
              _this7.$confirm(_this7.$t('blExchangeAppointment.confirmOriginalBl'), _this7.$t('confirmMsg.title'), {
                confirmButtonText: _this7.$t('confirmMsg.submit'),
                cancelButtonText: _this7.$t('confirmMsg.cancel'),
                type: 'warning'
              }).then(function () {
                _this7.handleHotTableSelections(hotTableSelections, firstPort);
              }).catch(function () {
                _this7.$message({
                  type: 'info',
                  message: _this7.$t('blExchangeAppointment.portReleasePending')
                });
              });
            } else {
              _this7.handleHotTableSelections(hotTableSelections, firstPort);
            }
          });
        } else {
          this.$confirm(this.$t('blExchangeAppointment.confirmOriginalBl'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.submit'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            _this7.handleHotTableSelections(hotTableSelections, firstPort);
          }).catch(function () {
            _this7.$message({
              type: 'info',
              message: _this7.$t('blExchangeAppointment.portReleasePending')
            });
          });
        }
      } else {
        this.handleHotTableSelections(hotTableSelections, firstPort);
      }
    },
    handleHotTableSelections: function () {
      var _handleHotTableSelections = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(hotTableSelections, firstPort) {
        var _this8 = this;
        var vvl, bookingHeadIds, forespeakStatusBlNo, containerStatusBlNo, isLockBlNo;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.filterForm.portCode == 'CNSHK')) {
                _context.next = 5;
                break;
              }
              this.vvls = Array.from(new Set(hotTableSelections.map(function (selection) {
                return selection.vvls;
              })));
              // 完船确认校验
              this.loading = (0, _utils.load)();
              _context.next = 5;
              return (0, _blExchangeAppointment.checkVesselComplete)({
                del: firstPort,
                vvls: this.vvls
              }).then(function (res) {}).finally(function () {
                _this8.loading.close();
              });
            case 5:
              // 海港校验是否上传水单
              if (this.filterForm.portCode == 'CNTXG') {
                this.slipUploadFlag = hotTableSelections.some(function (selection) {
                  return selection.slipUpload == '1';
                });
              }
              vvl = hotTableSelections.map(function (selection) {
                if (_this8.filterForm.portCode == 'CNSHK') {
                  return "VVL:".concat(selection.outVesselCode, "/").concat(selection.outVoyageNo).concat(selection.outVoyageLeg, ",BL:").concat(selection.blNo, ",RS:").concat(_this8.releaseStatusMap.get(selection.releaseStatus));
                } else {
                  return "VVL:".concat(selection.outVesselCode, "/").concat(selection.outVoyageNo).concat(selection.outVoyageLeg, ",BL:").concat(selection.blNo);
                }
              });
              this.vvLBlNo = vvl.join(',\n');
              this.forespeakBlNo = hotTableSelections.filter(function (selection) {
                return selection.blNo;
              }).map(function (selection) {
                return selection.blNo;
              });
              bookingHeadIds = hotTableSelections.filter(function (selection) {
                return selection.bookingHeadId;
              }).map(function (selection) {
                return selection.bookingHeadId;
              }).join(',');
              if (firstPort.startsWith('PH')) {
                this.printDialog = {
                  bookingHeadIds: bookingHeadIds,
                  blNo: hotTableSelections[0].blNo,
                  eta: hotTableSelections[0].eta,
                  del: hotTableSelections[0].del
                };
              }
              // 1、已预约的提单不能进行批量预约：forespeakStatus 1 已预约
              // 2、批量预约的提单号提单性质不一致：containerStatus ，判断箱型不为空且存在箱型有一种以上
              // 3、已锁定的提单不能进行批量预约：isLock 1 已锁定
              forespeakStatusBlNo = [];
              containerStatusBlNo = [];
              isLockBlNo = [];
              hotTableSelections.forEach(function (selection) {
                if (selection.forespeakStatus !== 0) {
                  forespeakStatusBlNo.push(selection.blNo);
                }
                if (selection.containerStatus) {
                  var containerStatusArray = selection.containerStatus.split(',');
                  if (containerStatusArray.length > 1) {
                    containerStatusBlNo.push(selection.blNo);
                  }
                }
                if (selection.isLock == 1) {
                  isLockBlNo.push(selection.blNo);
                }
              });
              if (!(forespeakStatusBlNo.length > 0 && this.filterForm.portCode !== 'CNXMN')) {
                _context.next = 18;
                break;
              }
              this.$message.error(this.$t('blExchangeAppointment.alreadyReserved', {
                blNo: forespeakStatusBlNo.join(', ')
              }));
              return _context.abrupt("return");
            case 18:
              if (!(containerStatusBlNo.length > 0)) {
                _context.next = 21;
                break;
              }
              this.$message.error(this.$t('blExchangeAppointment.inconsistentNature', {
                blNo: containerStatusBlNo.join(', ')
              }));
              return _context.abrupt("return");
            case 21:
              if (!(isLockBlNo.length > 0)) {
                _context.next = 24;
                break;
              }
              this.$message.error(this.$t('blExchangeAppointment.lockedBill', {
                blNo: isLockBlNo.join(', ')
              }));
              return _context.abrupt("return");
            case 24:
              this.paymentStatus = hotTableSelections[0].paymentStatus;
              this.forespeakStatus = hotTableSelections[0].forespeakStatus;
              this.setDialogVisible(firstPort);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleHotTableSelections(_x, _x2) {
        return _handleHotTableSelections.apply(this, arguments);
      }
      return handleHotTableSelections;
    }(),
    setDialogVisible: function setDialogVisible(firstPort) {
      var portDialogMapping = {
        'CNNGB': 'batchReservationNbVisible',
        'CNTAO': 'batchReservationQdVisible',
        'CNSHK': 'batchReservationSkVisible',
        'CNTXG': 'batchReservationXgVisible',
        'CNXMN': 'batchReservationXmVisible'
      };
      this.del = firstPort;
      if (firstPort.startsWith('PH')) {
        this.batchReservationPhVisible = true;
      } else if (portDialogMapping[firstPort]) {
        this[portDialogMapping[firstPort]] = true;
      } else {
        this.batchReservationCommonVisible = true;
      }
    },
    handleNextContainer: function handleNextContainer() {
      this.batchReservationPhVisible = false;
      this.searchContainerDialogVisible = true;
    },
    handleNextConfirmPrint: function handleNextConfirmPrint() {
      this.searchContainerDialogVisible = false;
      this.confirmPrintingDialogVisible = true;
    },
    //上一步
    handlePreviousStep: function handlePreviousStep() {
      this.searchContainerDialogVisible = true;
      this.confirmPrintingDialogVisible = false;
    },
    forespeakStatusRenderer: function forespeakStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
      var _this9 = this;
      // 清空单元格内容
      Handsontable.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      if (value === 1) {
        // link.innerText = '已预约';
        link.innerText = this.$t('blExchangeAppointment.reserved');
        link.addEventListener('click', function () {
          return _this9.handleViewDetail(row);
        });
      } else if (value === 2) {
        // link.innerText = '预约已保存，在审核附件格式';
        link.innerText = this.$t('blExchangeAppointment.reservationSaved');
        link.addEventListener('click', function () {
          return _this9.handleViewDetail(row);
        });
      } else {
        // link.innerText = '未预约';
        link.innerText = this.$t('blExchangeAppointment.notReserved');
        link.addEventListener('click', function () {
          return _this9.handleViewDetail(row);
        });
      }

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    columnRenderer: function columnRenderer(instance, td, row, col, prop, value, cellProperties) {
      switch (value) {
        case 0:
          // td.innerHTML = '未发送';
          td.innerHTML = this.$t('blExchangeAppointment.unSend');
          break;
        case 1:
          // td.innerHTML = '发送';
          td.innerHTML = this.$t('blExchangeAppointment.send');
          break;
        default:
          td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleCloseReservationCommon: function handleCloseReservationCommon() {
      this.batchReservationCommonVisible = false;
      this.handleSearch();
    }
  }
};